import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material';
import { MarketButton } from '@market/react';
import ReaderContactless from '@square-icons/react/80/Hardware/reader-contactless';
import { useOrderDetails } from 'components/context/order_details';
import { isDashboardMode } from 'helpers/search_parameter_helpers';

const EmptyCart = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { store, language } = useOrderDetails();

  return (
    <>
      <div style={{ margin: theme.spacing(5, 0), textAlign: 'center' }}>
        <ReaderContactless />
        <h2>{t('cart.label.emptyTitle')}</h2>
        <p>{t('cart.label.emptySubtitle')}</p>
        <MarketButton
          id="cart-browse-btn"
          rank="primary"
          style={{ marginTop: theme.spacing(2) }}
          onClick={() => {
            const hardwareUrl = `/${store.toLowerCase()}/${language}/hardware`;

            if (isDashboardMode()) {
              window.open(hardwareUrl, '_blank');

              window.location = '/dashboard';
            } else {
              window.location = hardwareUrl;
            }
          }}
        >
          {t('cart.label.browse')}
        </MarketButton>
      </div>
    </>
  );
};

export default EmptyCart;
